import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.administrators-developers', {
        url: '/administrators-developers',
        component: 'companyUserDirectoriesSaaspassUsersAdministratorsDevelopers',
    });
}

/** @ngInject */
function accounts(companyId, UsersResource) {
    return UsersResource.getAllRegularCompanyUsers(companyId, 'roles');
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/administrators-developers/administrators-developers.state.js